export const CREATED = {
  status: 201,
  message: '201 Created',
} as const

export const ACCEPTED = {
  status: 202,
  message: '202 Accepted',
} as const

export const NO_CONTENT = {
  status: 204,
  message: '204 No Content',
} as const

export const UNAUTHORIZED = {
  status: 401,
  message: '401 Unauthorized Error',
} as const

export const NOT_FOUND = {
  status: 404,
  message: '404 Not Found',
} as const

export const CONFLICT = {
  status: 409,
  message: '409 Conflict',
} as const

export const GONE = {
  status: 410,
  message: '410 Gone',
} as const

export const TOO_MANY_REQUESTS = {
  status: 429,
  message: '429 Too Many Requests',
} as const
